module.exports = __webpack_public_path__ + "static/media/img_section03_finding04.236c1f36.png";